import React from 'react';
import type { Meta, Story } from '@storybook/react';
import TopBanner from './TopBanner';
import type { TopBannerProps } from './TopBanner.types';
import Page from '../Page';
import Button from '../Button';
import { More } from '@wix/wix-ui-icons-common';
import { Breadcrumbs, Card, CloseButton, IconButton, Modal, Text } from '..';

const meta: Meta<typeof TopBanner> = {
  title: 'TopBanner',
  component: TopBanner,
};

export default meta;

const commonProps: TopBannerProps = {
  dismissible: true,
  dismissLabel: 'dismiss-label',
  position: 'sticky',
  dataHook: 'top-banner',
  action: <TopBanner.ActionButton>Upgrade</TopBanner.ActionButton>,
  children: 'Upgrade your site to start accepting payments.',
};

export const Basic: Story = () => <TopBanner {...commonProps} />;

export const InPage: Story = () => (
  <div style={{ height: '800px', overflow: 'scroll', position: 'relative' }}>
    <TopBanner {...commonProps}></TopBanner>
    <Page height="1600px">
      <Page.Header
        title="Page Title"
        breadcrumbs={
          <Breadcrumbs
            items={[
              { id: 0, value: 'Page Name' },
              { id: 1, value: 'Page title' },
            ]}
          />
        }
        subtitle="I’m a relatively long subtitle to fill this space in."
        actionsBar={
          <div style={{ display: 'flex', gap: 6 }}>
            <IconButton
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <More />
            </IconButton>
            <Button skin="light">Button</Button>
            <Button skin="standard">Button</Button>
          </div>
        }
      />
      <Page.Content>
        <Text>This is text</Text>
      </Page.Content>
    </Page>
  </div>
);

export const InModal: Story = () => {
  return (
    <Modal isOpen={true}>
      <Card stretchVertically>
        <Card.Header
          suffix={<CloseButton />}
          title="Title"
          subtitle="I’m a relatively long subtitle to fill this space in."
        />
        <Card.Content>
          <div style={{ overflow: 'scroll', height: '400px' }}>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt
              modi a atque illum deleniti veniam, quibusdam ad dignissimos
              excepturi ex itaque incidunt corrupti earum! Laboriosam laborum
              eos asperiores mollitia dicta?
            </Text>
            <TopBanner {...commonProps}></TopBanner>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt
              modi a atque illum deleniti veniam, quibusdam ad dignissimos
              excepturi ex itaque incidunt corrupti earum! Laboriosam laborum
              eos asperiores mollitia dicta?
            </Text>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt
              modi a atque illum deleniti veniam, quibusdam ad dignissimos
              excepturi ex itaque incidunt corrupti earum! Laboriosam laborum
              eos asperiores mollitia dicta?
            </Text>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt
              modi a atque illum deleniti veniam, quibusdam ad dignissimos
              excepturi ex itaque incidunt corrupti earum! Laboriosam laborum
              eos asperiores mollitia dicta?
            </Text>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt
              modi a atque illum deleniti veniam, quibusdam ad dignissimos
              excepturi ex itaque incidunt corrupti earum! Laboriosam laborum
              eos asperiores mollitia dicta?
            </Text>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt
              modi a atque illum deleniti veniam, quibusdam ad dignissimos
              excepturi ex itaque incidunt corrupti earum! Laboriosam laborum
              eos asperiores mollitia dicta?
            </Text>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt
              modi a atque illum deleniti veniam, quibusdam ad dignissimos
              excepturi ex itaque incidunt corrupti earum! Laboriosam laborum
              eos asperiores mollitia dicta?
            </Text>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt
              modi a atque illum deleniti veniam, quibusdam ad dignissimos
              excepturi ex itaque incidunt corrupti earum! Laboriosam laborum
              eos asperiores mollitia dicta?
            </Text>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt
              modi a atque illum deleniti veniam, quibusdam ad dignissimos
              excepturi ex itaque incidunt corrupti earum! Laboriosam laborum
              eos asperiores mollitia dicta?
            </Text>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt
              modi a atque illum deleniti veniam, quibusdam ad dignissimos
              excepturi ex itaque incidunt corrupti earum! Laboriosam laborum
              eos asperiores mollitia dicta?
            </Text>
          </div>
        </Card.Content>
      </Card>
    </Modal>
  );
};

export const WithCustomContent: Story = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'red',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <TopBanner {...commonProps}>
        <div style={{ display: 'flex', gap: '6px', width: '100%' }}>
          <div
            style={{
              backgroundColor: 'purple',
              width: '70%',
              padding: '3px',
              borderRadius: '3px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            Lorem ipsum dolor, sit amet consectetur adipisicing elit.
          </div>
          <div
            style={{
              backgroundColor: 'pink',
              width: '30%',
              padding: '3px',
              borderRadius: '3px',
            }}
          >
            Lorem ipsum dolor, sit amet consectetur adipisicing elit.
          </div>
        </div>
      </TopBanner>
    </div>
  );
};
